module.exports = __webpack_public_path__ + "static/img/logo-sovrn.d1238a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-sovrn.png
// module id = RngP
// module chunks = 1